module.exports = __webpack_public_path__ + "img/join-to-the-contest.12e78986.svg";